(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const schemata = require('schemata')
const required = require('@clocklimited/validity-required')
const generateSalt = require('./lib/salt-generator')
const email = require('@clocklimited/validity-email')

module.exports = function (save) {
  function duplicateEmailValidator (key, errorProperty, object, callback) {
    save.findOne({ emailAddress: new RegExp([ '^', object.emailAddress, '$' ].join(''), 'i') }
      , function (error, found) {
      if (error) {
        return callback(error)
      }
      callback(undefined, found && found._id.toString() !== object._id ?
        object.emailAddress + ' already in use' : undefined)
    })
  }

  return schemata(
    { _id:
      { type: String
      , tag: [ 'update', 'partialUpdate' ]
      }
    , emailAddress:
      { type: String
      , validators:
        { all: [ required, email, duplicateEmailValidator ]
        }
      , tag: [ 'update' ]
      }
    , firstName:
      { type: String
      , validators:
        { all: [ required ]
        }
      , tag: [ 'update' ]
      }
    , lastName:
      { type: String
      , tag: [ 'update' ]
      }
    , mobile:
      { type: String
      , tag: [ 'update' ]
      }
    , enabled:
      { type: Boolean
      , tag: [ 'update' ]
      }
    , featured:
      { type: Boolean
      , tag: [ 'update' ]
      }
    , artists:
      { type: Array
      , tag: [ 'update' ]
      }
    , password:
      { type: String
      , validators:
        { all: []
        }
      , tag: [ 'partialUpdate' ]
      }
    , passwordSalt:
      { type: String
      , defaultValue: generateSalt
      , tag: [ 'partialUpdate' ]
      }
    , ssoOnly:
      { type: Boolean
      , tag: [ 'update' ]
      , defaultValue: false
      }
    , key:
      { type: String
      }
    , keyExpiry:
      { type: Date
      }
    , twoFaEnabled:
      { type: Boolean
      , defaultValue: true
      , tag: ['update']
      }
    , twoFaKey:
      { type: String
      , tag: ['update']
      }
    , twoFaChallengeDates:
      { type: Object
      , tag: ['update']
      , defaultValue: function () { return {} }
      }
    , failedLoginAttempts:
      { type: Number
      , defaultValue: 0
      }
    , nextAllowedLoginAttemptDate:
      { type: Date
      }
    , roles:
      { type: Array
      , validators:
        { all: [ required ]
        }
      , tag: [ 'update' ]
      }
    , created:
      { type: Date
      , validators:
        { all: []
        }
      , defaultValue: function () { return new Date() }
      }
    , sendInvite:
      { type: Boolean
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/administrator/schema.js","/components/service/administrator")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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